const validationRule: Object = { required: true };
const validationNumberRule: Object = { required: true, number: true };
export const preloadColumns = [
  {
    field: 'id',
    headerText: 'ID',
    width: '100',
    textAlign: 'Left',
    isPrimary: true,
    visible: false,
    allowEditing:false,
  },
  {
    field: 'pitt',
    validationRules: validationRule,
    headerText: 'Pit',
    allowEditing:true,
  },
  {
    field: 'shot_id',
    validationRules: validationNumberRule,
    headerText: 'Shot ID',
    allowEditing:true,
    editType:'numericedit'
  },
  {
    field: 'no_holes',
    validationRules: validationRule,
    headerText: 'No.Holes',
    allowEditing:true,
  },
  {
    field: 'product',
    validationRules: validationRule,
    headerText: 'Product',
    allowEditing:true,
  },
  {
    field: 'comments',
    validationRules: validationRule,
    headerText: 'Comments',
    allowEditing:true,
  },
];
